export default "__VITE_ASSET__CYvi1s$R__"